// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"d94a917e","273":"d493eede","307":"3f520ef0","453":"7ec8e0b8","543":"4b0a21fd","603":"ea03a1e5","615":"1ed5d2c0","628":"d01bcabb","693":"33f75867","816":"b5188040","953":"71e32d38"}[chunkId] + ".chunk.js";
};